import { OrderV2, Payment } from '@citruscamps/citrus-client'
import React from 'react'

interface IProps extends React.HTMLAttributes<HTMLSpanElement> {
  order: Partial<OrderV2>
  payments?: Payment[]
}

export const OrderStatusBadgeV2 = ({ order, className, ...props }: IProps): React.ReactElement => {
  let color: 'warning' | 'success' | 'danger' | 'light' = 'light'
  let content: string = order.status || ''
  switch (order.status) {
    case 'created':
      color = 'warning'
      break
    case 'paid':
    case 'fulfilled':
      content =
        order?.amount_remaining && order?.amount_remaining?.value > 0
          ? 'Partially paid'
          : order.status
      color = order?.amount_remaining && order?.amount_remaining?.value > 0 ? 'warning' : 'success'
      break
    case 'returned':
      content =
        order?.amount_returned?.value !== order?.amount_paid?.value
          ? 'Partial refund'
          : order.status
      break
    case 'disputed':
      const payment: Payment | undefined = props?.payments?.find((payment) => 'dispute' in payment)
      switch (payment?.dispute?.status) {
        case 'needs_response':
        case 'under_review':
          color = 'danger'
          content = payment?.dispute?.status || 'disputed'
          break
        case 'won':
          color = 'success'
          content = payment?.dispute?.status || 'disputed'
          break
        case 'lost':
          color = 'light'
          content = 'disputed'
          break
        case 'charge_refunded':
        case 'warning_needs_response':
        case 'warning_under_review':
        case 'warning_closed':
        default:
          color = 'light'
          content = order.status
          break
      }
      break
    case 'canceled':
    default:
  }
  return (
    <span
      className={`badge rounded-pill text-bg-${color} text-capitalize${
        className ? ` ${className}` : ''
      }`}
      style={{
        verticalAlign: 'text-top',
        ...props.style,
      }}
      {...props}
    >
      {content.split('_').join(' ')}
    </span>
  )
}
